"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var progress_style_1 = require("./progress-style");
function Progress(props) {
    return (0, jsx_runtime_1.jsx)(progress_style_1.StyledProgress, __assign({}, props));
}
exports.Progress = Progress;
